module.exports = __webpack_public_path__ + "299b3be898e809232985246037e615b9.woff";